import { render, staticRenderFns } from "./DetailDocPdfViewer.vue?vue&type=template&id=cfd3f9fe"
import script from "./DetailDocPdfViewer.vue?vue&type=script&lang=js"
export * from "./DetailDocPdfViewer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports